import { conceptType } from '../variables/Enums';
import axios from './index';

export const searchConcept = (conceptId, term, type = conceptType.events) => {
    return axios.get(`api/v1/snowstorm/${type}/SearchConcept/${conceptId}/${term}`);
};

export const searchConceptByExpression = (expression, term, type = conceptType.events) => {
    return axios.get(`api/v1/snowstorm/${type}/SearchByExpression/${expression}/${term}`);
};